import React from 'react';
import { connect } from 'react-redux';
import get from 'lodash/get';
import { BUILDER } from '../../../../src/shared/abilities';
import { compose } from '../../../../src/web/utils/react';
import Field from '../../../../modules/react/components/stateful/Field';
import Input from '../../../../modules/react/components/stateful/Input';
import Reviews from './Reviews';
import { NAME, ID } from './properties';
import { editModal, widget } from '../../../../src/web/components/widgets/decorators';
import style from './Reviews.scss';
import { load as loadReviews } from '../../../../src/web/store/modules/googleReviews';


const component = compose(
  editModal(
    props => ({
      name: 'review widget',
      title: 'Review Widget',
      initialValues: {
        googlePlaceId: props.googlePlaceId,
      },
    }),
    [{
      children: (
        <Field
          label="Google Place ID"
          name="googlePlaceId"
          id="googlePlaceId"
          component={Input}
          groupClassName={style.heading}
          help={(
            <span className={style.text}>
              <a
                href="https://developers.google.com/places/place-id"
                target="_blank"
                rel="noopener noreferrer"
              >
                  This tool
              </a>
              {' '}
                is useful for looking up place IDs.
            </span>
            )}
        />
      ),
    }],
  ),
  widget(
    { name: NAME, category: 'Reviews', componentId: ID },
    {
      defaults: { googlePlaceId: null },
      resolve: ({ payload: { googlePlaceId } }) => {
        if (googlePlaceId) {
          return [loadReviews(googlePlaceId)];
        }

        return null;
      },
    },
  ),
  connect(
    (state, { googlePlaceId }) => ({
      reviews: get(state, ['googleReviews', googlePlaceId], []),
    }),
  ),
)(Reviews);

component.authorization = { action: 'manage', subject: BUILDER };

export default component;
